import { useEffect, useState } from "react";
import { IFormSection, TSubmitType } from "../../types/common";
import {
  API_INVOICES,
  API_MOCK_PAYMENTS,
  API_PAYMENT_MODES_CONFIGURABLES,
} from "../../utils/apis";

import useGet from "../common/useGet";
import { getResultOptions } from "../../utils/helpers";

export type TFormCustomProps = {
  id?: number;
  submitType?: TSubmitType;
};

export const useMakePaymentForm = ({ searchParams, form, updateFormValue }) => {
  const [invoiceAmount, setInvoiceAmount] = useState(0);
  const { loadData: getInvoices, data: invoices } = useGet();

  const getInvoiceOptions = (data: any) => {
    return data?.results?.length
      ? data.results
          .filter((item: any) => item.payment_status !== "paid")
          .map((item: any) => ({
            id: item.id,
            name: item.invoice_number,
            data: item,
          }))
      : [];
  };
  useEffect(() => {
    getInvoices({
      api: API_INVOICES,
      params: {
        loan_application: searchParams?.loan_application,
      },
    });
  }, []);

  useEffect(() => {
    if (form?.invoice_id) {
      const invoice = invoices?.results?.find(
        (item: any) => item.id === form?.invoice_id,
      );
      setInvoiceAmount(invoice?.amount - invoice?.amount_paid || 0);
      updateFormValue("amount", invoice?.amount - invoice?.amount_paid || 0);
    }
  }, [form?.invoice_id]);

  const sections: IFormSection[] = [
    {
      title: "Payment Information",
      fields: [
        {
          field_name: "invoice_id",
          type: "select",
          label: "Invoices",
          props: { required: true, smallWidth: true },
          options_name: "invoices",
        },
        {
          field_name: "invoice_amount",
          type: "number",
          label: "Invoice Amount",
          value: invoiceAmount,
          visible: invoiceAmount > 0,
          props: { disabled: true, smallWidth: true },
        },
        {
          field_name: "amount",
          type: "decimal",
          label: "Amount",
          props: { required: true, smallWidth: true, step: "any" },
        },
        {
          field_name: "payment_mode",
          type: "select",
          label: "Payment Method",
          props: { required: true, smallWidth: true },
          options_name: "payment_modes",
        },
        {
          field_name: "payment_date",
          type: "date",
          label: "Payment Date",
          props: {
            required: true,
            smallWidth: true,
          },
        },
      ],
    },
  ];

  const getConfigOptions = () => {
    const { loadData: getPaymentModes, data: paymentModes } = useGet();
    useEffect(() => {
      getPaymentModes({
        api: API_PAYMENT_MODES_CONFIGURABLES,
        params: { active: true },
      });
    }, []);

    return {
      payment_modes: getResultOptions(paymentModes, "mode", "mode"),
    };
  };

  const redirect = `/loan_application/view/${searchParams?.loan_application}`;

  const options = {
    invoices: getInvoiceOptions(invoices),
    ...getConfigOptions(),
  };

  return { sections, redirect, options };
};

export function submitMakePayment(payload: any, id: number | null) {
  if (id) {
    return {
      id,
      api: API_MOCK_PAYMENTS,
      params: payload,
    };
  }
  // on create
  return {
    api: API_MOCK_PAYMENTS,
    params: payload,
  };
}
